import React from "react";

const TermsOfUse = (props) => {
    return (
        <>
        <div className={`column is-flex is-flex-direction-column ${props.className}`}>
            <h1 className="h1 colorBlack">{props.title}</h1>
            <p className="subtitle colorBlack"><span className="is-bold">Effective Date:</span> {props.effectiveDate}</p>
            <p>Applies to kindersmeats.com and any related subdomains or landing pages.</p>

            <h2 className="h2">1. Acceptance of Terms</h2>
            <p>By accessing or using this website ("Site"), you agree to be bound by these Terms of Use and all applicable laws and regulations. If you do not agree with these terms, do not use this Site.</p>

            <h2 className="h2">2. Ownership and Use of Content</h2>
            <p>All text, images, logos, graphics, and content on this Site are the property of JDK & Company, Inc. ("Kinder's") or licensed for use by Kinder's. You may use this content for personal, non-commercial purposes only. Any other use, including reproduction, distribution, or modification, is prohibited without our prior written consent.</p>

            <h2 className="h2">3. Online Ordering and Third-Party Links</h2>
            <p>This Site may link to third-party services such as Heartland POS (pickup orders) and DoorDash (delivery). Kinder's is not responsible for these platforms' availability, accuracy, or data practices. Their own terms and privacy policies govern the use of those services.</p>

            <h2 className="h2">4. User Submissions</h2>
            <p>Any information, feedback, or submissions you provide through forms or other channels on this Site must be accurate and lawful. You agree not to submit false information or content that infringes on the rights of others. We reserve the right to remove any content that violates these Terms or is otherwise inappropriate.</p>

            <h2 className="h2">5. Disclaimers</h2>
            <p>This Site is provided "as is" and "as available." While we strive to ensure the accuracy of content and the availability of services, we make no warranties regarding the completeness, reliability, or uninterrupted access to the Site.</p>

            <h2 className="h2">6. Limitation of Liability</h2>
            <p>To the fullest extent allowed by law, Kinder's shall not be liable for any indirect, incidental, or consequential damages arising from your use of, or inability to use, this Site—even if we were advised of the possibility of such damages.</p>

            <h2 className="h2">7. Indemnification</h2>
            <p>You agree to indemnify and hold harmless Kinder's and its officers, employees, and affiliates from any claim or demand arising from your misuse of the Site or violation of these Terms.</p>

            <h2 className="h2">8. Governing law</h2>
            <p>The laws of the State of California govern these Terms. Any disputes shall be resolved in the courts of Contra Costa County, California.</p>

            <h2 className="h2">9. Modifications</h2>
            <p>We reserve the right to update or modify these Terms at any time. Updates will be posted on this page, and your continued use of the Site signifies acceptance of those changes.</p>

            <h2 className="h2">10. Contact Information</h2>
            <p>If you have any questions about these Terms of Use, or need to contact us regarding the Site,  please contact:</p>

            <h3 className="h3">Mailing Address</h3> 
            <p>JDK & Company, Inc.<br />
            1150 Burnett Ave., Suite D<br />
            Concord, CA 94520<br />
            Email: <a href="mailto:corporate@kinderscorp.com">corporate@kinderscorp.com</a><br />
            Phone: <a href="tel:+19253637367">(925) 363-7367</a></p>
        </div>
        </>
    );

}

export default TermsOfUse;